const formatErrorMsg = (error) => error && error.replace('Error: ', '')

exports.formatErrorMsg = formatErrorMsg
